import styles from "./index.module.css";
//import Navigation from "components/Navigation";
import Topbar from "components/Topbar";


// eslint-disable-next-line no-unused-vars
const Navbar = (props) => {
    return (
        <div>
            {/* <Navigation
        items={[
          {
            itemId: "1",
            title: "Fă o programare nouă",
            path: "/",
          },
          {
            itemId: "2",
            title: "Locația Biroului de Asistență",
            path: "/",
          },
          {
            itemId: "3",
            title: "Program de funcționare",
            path: "/",
          },
          {
            itemId: "4",
            title: "Regulament de funcționare",
            path: "/",
          },
        ]}
      /> */}
        </div>
    );
};

// eslint-disable-next-line react/prop-types
export default function DashboardLayout({ children }) {
    return (
        <>
            <Topbar />
            <div className={styles.page}>
                {children}
            </div>
        </>
    );
}
